<template>
  <div>
    <div class="header mb-10">
      <el-button
        @click="handleNew()"
        type="primary"
        icon="el-icon-plus"
        size="small"
        v-permission="Auth.ccmCategoryNew"
        >新增分类</el-button
      >
    </div>
    <el-table
      v-if="!isMobile()"
      v-loading="loading"
      :data="cates"
      stripe
      header-row-class-name="q-products-header"
    >
      <el-table-column prop="name" label="分类名" align="left">
        <template slot-scope="scope">
          {{ scope.row.whole_name.replace(/,/g, ' - ') }}
        </template>
      </el-table-column>
      <el-table-column label="分类级别" align="left">
        <template slot-scope="scope">
          {{ scope.row.father_id > 0 ? '二级分类' : ' 一级分类' }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleNew(scope.row, scope.$index)"
            v-permission="Auth.ccmCategoryNew"
            v-if="scope.row.father_id == 0"
            >添加子分类</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleEdit(scope.$index, scope.row)"
            v-permission="Auth.ccmCategoryEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.ccmCategoryDelete"
            title="确认删除吗？"
            @confirm="handleDelete(scope.$index, scope.row)"
          >
            <el-button
              class="ml-10"
              slot="reference"
              type="danger"
              plain
              size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="(item, index) in cates">
        <div style="display: flex; justify-content: space-between">
          <div>
            <div>
              分类名：{{ item.whole_name.replace(/,/g, ' - ') }}（{{
                item.father_id > 0 ? '二级' : ' 一级'
              }}）
            </div>
          </div>
        </div>
        <div class="mt-10">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleNew(item, index)"
            v-permission="Auth.ccmCategoryNew"
            v-if="item.father_id == 0"
            >添加子分类</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleEdit(index, item)"
            v-permission="Auth.ccmCategoryEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.ccmCategoryDelete"
            title="确认删除吗？"
            @confirm="handleDelete(index, item)"
          >
            <el-button
              class="ml-10"
              slot="reference"
              type="danger"
              plain
              size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </div>
      </li>
    </ul>
    <el-pagination
      class="mt-20"
      :current-page.sync="filter.page"
      layout="total, prev, pager, next"
      @current-change="handlePageChange"
      :page-size="filter.size"
      :total="total"
    ></el-pagination>

    <item-category-former
      :model="cateForm"
      :show.sync="cateVisible"
      :cates="cates"
      @created="createdModel"
      @updated="updatedModel"
    ></item-category-former>
  </div>
</template>

<script>
import itemCategoryFormer from './former.vue'
import { ccmCategoryList, deleteCCMCategory } from '@/service/getData'
import { clone } from '@/util'
import { isMobile } from '@/util/index'

export default {
  props: {
    filter: Object,
  },
  watch: {
    filter: {
      handler(newVal) {
        this.requestItemCategoryList()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isMobile,
      loading: true,
      total: 0,
      cates: [],
      cateForm: {},
      cateVisible: false,
      editIndex: 0,
    }
  },
  components: {
    itemCategoryFormer,
  },
  methods: {
    async requestItemCategoryList() {
      let data = clone(this.filter)
      data.page = data.page - 1
      this.loading = true

      let res = await ccmCategoryList(data)
      if (res.code == 0) {
        this.cates = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestItemCategoryList()
    },
    createdModel(res) {
      this.cates.splice(this.editIndex, 0, res)
    },
    updatedModel(res) {
      this.cates[this.editIndex].whole_name = res.whole_name
      this.cates[this.editIndex].name = res.name
      this.cates[this.editIndex].father = res.father
      this.cates[this.editIndex].father_id = res.father.id
    },
    handleNew(cate, index) {
      this.editIndex = 0
      let father_id = 0
      let level = 1
      let father_name = ''
      if (cate) {
        this.editIndex = index + 1
        father_id = cate.id
        father_name = cate.name
        level = cate.level + 1
      }
      this.cateForm = {
        name: '',
        father_id: father_id,
        level: level,
        father_name: father_name,
      }
      this.cateVisible = true
    },
    handleEdit(index, item) {
      this.cateVisible = true
      this.$nextTick(() => {
        this.cateForm = clone(item)
        this.cateForm.father_name = this.cateForm.father.name
        this.editIndex = index
      })
    },

    deleteCallBack(id) {
      let cates = this.cates.filter(
        (item) => item.father_id == id || item.id == id
      )
      this.cates = this.cates.filter(
        (item) => item.father_id != id && item.id != id
      )
      if (cates.length > 0) {
        cates.map((item) => {
          this.deleteCallBack(item.id)
        })
      }
    },
    async handleDelete(index, it) {
      let res = await deleteCCMCategory(it.id)
      if (res.code == 0) {
        this.deleteCallBack(it.id)
      }
    },
  },
}
</script>